module.exports = __webpack_public_path__ + "static/media/gadis_final.38dbfd1f.jpg";